import {EntityState} from "@datorama/akita"
import {are_cookies_enabled, storageAvailable} from "utils/browserChecks"
import {isMobile} from "utils/isMobile"

export interface IEnvStore extends EntityState {
  loading: undefined | boolean
  language: IEnvLanguages | undefined
  languageLoading: boolean
  theme: IEnvThemes
  themeMode: IEnvThemeModes
  allowsCookies: undefined | boolean
  allowsLocalStorage: undefined | boolean
  formsInline: boolean
  isMobileJs: boolean
  isMobileWidth: boolean | undefined
}

export const envCreateInitState = (): IEnvStore => {
  const allowsCookies = are_cookies_enabled()
  const allowsLocalStorage = storageAvailable('localStorage')

  return {
    loading: undefined,
    language: undefined,
    languageLoading: true,
    theme: 'default',
    themeMode: undefined,
    allowsCookies,
    allowsLocalStorage,
    formsInline: false,
    isMobileJs: isMobile(navigator.userAgent || navigator.vendor || window.opera),
    isMobileWidth: undefined,
  }
}

export type IEnvLanguages = ILngNl | ILngEn | undefined
export type ILngNl = 'nl' | 'nld'
export type ILngEn = 'en' | 'eng'

export type IEnvThemes = 'default'
export type IEnvThemeModes = 'light' | 'dark' | undefined
